import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

import { AdminContext } from '../../store/contexts';
import { AdminFooter } from '../admin/AdminFooter';
import { AdminNavbar } from '../admin/AdminNavbar';
import { ToastNotifications } from '../notifications/ToastNotifications';

export const AdminLayout = () => {
    const user = useSelector((state) => state.auth.user);

    if (user === null) {
        return <Navigate to="/error/401" replace />;
    }

    if (user.role !== 'admin') {
        return <Navigate to="/error/403" replace />;
    }

    return (
        <AdminContext.Provider value={{}}>
            <div className="main-layout d-flex flex-column min-vh-100">
                <main className="main-page flex-shrink-0 mb-auto">
                    <AdminNavbar user={user} />
                    <div className="container-fluid">
                        <div className="container">
                            <Outlet />
                        </div>
                        <ToastNotifications />
                    </div>
                </main>
                <AdminFooter user={user} />
            </div>
        </AdminContext.Provider>
    );
};
